import { motion } from "framer-motion";
import { images } from "../data/siteData";

export default function EbookCover({ compact = false }) {
  return (
    <motion.div
      className={`ebook-cover ${compact ? "ebook-cover-compact" : ""}`}
      whileHover={{ rotate: 0, scale: 1.03 }}
      transition={{ type: "spring", stiffness: 180, damping: 16 }}
    >
      <img src={images.ebook} alt="Elite Nutrition Blueprint eBook cover" />
    </motion.div>
  );
}
